import { BaseUser } from '@core/models/user';
import { getCropwiseUser } from '@core/services/base.service';
import { setToken } from '@cw-elements/config';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { ModulesError } from './modules-error.component';
import { ModulesLoading } from './modules-loading.component';

export type ModulesOutletContext = {
  user: BaseUser;
};

function ModulesContainer() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const token = params.get('token');

  const { data: query, isLoading } = useQuery({
    queryKey: ['cropwise-user', token],
    queryFn: () => getCropwiseUser(token ?? ''),
    enabled: !!token,
  });

  useEffect(() => {
    if (token) {
      setToken(token);
    }
  }, [token]);

  if (!token) {
    return (
      <ModulesError
        message={t('modules.alerts.missing_token.message')}
        description={t('modules.alerts.missing_token.description')}
      />
    );
  }

  if (isLoading) {
    return <ModulesLoading />;
  }

  if (query?.data) {
    return <Outlet context={{ user: query.data }} />;
  }

  return null;
}

export { ModulesContainer };
